export const ICONS = {
  file: 'tc-icon-file',
  visibilityOn: 'tc-icon-eye-visibility',
  visibilityOff: 'tc-icon-eye-visibility-off',
  visibilityOffDownload: 'tc-icon-eye-visibility-off-download',
  visibilityError: 'tc-icon-eye-visibility-off-error',
  collapsed: 'tc-icon-arrow-next',
  expanded: 'tc-icon-arrow-drop-down',
  add: 'tc-icon-content-add',
  remove: 'tc-icon-content-subtract',
  edit: 'tc-icon-edit',
  settings: 'tc-icon-settings',
  download: 'tc-icon-file-download',
  launch: 'tc-icon-launch',
} as const;

export type IconType = (typeof ICONS)[keyof typeof ICONS];
